module.exports = {
      id: "check-usage",
      viewBox: "0 0 11 9",
      url: __webpack_public_path__ + "img/icons.05c569e2.svg#check-usage",
      toString: function () {
        return this.url;
      }
    }